export const formatAddressLine = (address) => {
    if (!address?.street) {
        return undefined;
    }
    const number = [address.buildingNumber, address.apartmentNumber].filter(Boolean).join('/');
    return `${address.street}${number ? ' ' + number : ''}, ${address.postalCode} ${address.city}`;
};
